import { render, staticRenderFns } from "./Checkhomework.vue?vue&type=template&id=3001d3d1"
import script from "./Checkhomework.vue?vue&type=script&lang=js"
export * from "./Checkhomework.vue?vue&type=script&lang=js"
import style0 from "./Checkhomework.vue?vue&type=style&index=0&id=3001d3d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports